module.exports = __webpack_public_path__ + "img/pro_night_4.6224ed63.jpg";